import "@/App.css";
import TradingOS from "@/pages/TradingOS";
import "@/Experience.css";
import {ExperienceProvider} from "@/context/ExperienceContext";
import FormStudio from "@/pages/FormStudio";
import CodeReader from "@/pages/CodeReader";
import Experience from "@/pages/Experience";
import Safety from "@/pages/Safety";
import Organization from "@/pages/Organization";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LiveProvider } from "@/context/LiveContext";
import Login, { ChangePassword } from "@/pages/Login";
import InterfaceFrame from "@/components/jarvis/InterfaceFrame";
import Home from "@/pages/Home";
import DeviceControl from "@/pages/DeviceControl";
import SocialNetworks from "@/pages/SocialNetworks";
import Settings from "@/pages/Settings";
import Missions from "@/pages/Missions";
import Plants from "@/pages/Plants";
import PersonalOverview from "@/pages/PersonalOverview";
import More, {ModuleDetail} from "@/pages/More";
import PersonalSpace from "@/pages/PersonalSpace";
import LifeTracking from "@/pages/LifeTracking";
import CreatorStudio from "@/pages/CreatorStudio";
import FinanceCenter from "@/pages/FinanceCenter";
import Certification from "@/pages/Certification";
import Utilities from "@/pages/Utilities";
import {WalkthroughProvider} from "@/context/WalkthroughContext";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center hud-label" data-testid="auth-loading">Iniciando sistemas…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ChangePassword />;
  return <LiveProvider><InterfaceFrame>{children}</InterfaceFrame></LiveProvider>;
}

export default function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <ExperienceProvider><BrowserRouter><WalkthroughProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="/tv" element={<Protected><DeviceControl kind="tv" /></Protected>} />
            <Route path="/pc" element={<Protected><DeviceControl kind="pc" /></Protected>} />
            <Route path="/formularios" element={<Protected><FormStudio /></Protected>} />
            <Route path="/codigos" element={<Protected><CodeReader /></Protected>} />
            <Route path="/tradingos" element={<Protected><TradingOS /></Protected>} />
            <Route path="/organizacion" element={<Protected><Organization /></Protected>} />
            <Route path="/seguridad" element={<Protected><Safety /></Protected>} />
            <Route path="/experiencia" element={<Protected><Experience /></Protected>} />
            <Route path="/hoy" element={<Protected><PersonalOverview /></Protected>} />
            <Route path="/mas" element={<Protected><More /></Protected>} />
            <Route path="/modulos/:slug" element={<Protected><ModuleDetail /></Protected>} />
            <Route path="/plantas" element={<Protected><Plants /></Protected>} />
            <Route path="/certificacion" element={<Protected><Certification /></Protected>} />
            <Route path="/utilidades" element={<Protected><Utilities /></Protected>} />
            <Route path="/finanzas" element={<Protected><FinanceCenter /></Protected>} />
            <Route path="/creacion" element={<Protected><CreatorStudio /></Protected>} />
            <Route path="/vida-personal" element={<Protected><LifeTracking /></Protected>} />
            <Route path="/mi-espacio" element={<Protected><PersonalSpace /></Protected>} />
            <Route path="/misiones" element={<Protected><Missions /></Protected>} />
            <Route path="/redes" element={<Protected><SocialNetworks /></Protected>} />
            <Route path="/ajustes" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </WalkthroughProvider></BrowserRouter></ExperienceProvider>
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0F172A", border: "1px solid rgba(0,240,255,.3)", color: "#E2E8F0" } }} />
      </AuthProvider>
    </div>
  );
}
